module.exports = __webpack_public_path__ + "img/loading_wallpaper.e68259f8.jpg";